import { BadgeCheck, Recycle, Leaf, ShieldCheck, FlaskConical } from "lucide-react";
import { FadeUp, Overline } from "@/components/Motion";
import { CERTIFICATIONS } from "@/data/site";
import { useLang, TA, u } from "@/data/i18n";

const ICONS = [FlaskConical, ShieldCheck, BadgeCheck, Leaf, Recycle];

export default function Certifications() {
  const { lang } = useLang();
  return (
    <section data-testid="certifications-section" className="py-20 md:py-24 bg-white border-y border-ink/10">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <FadeUp className="text-center">
          <Overline>{u(lang, "cert_overline")}</Overline>
        </FadeUp>
        <div className="mt-10 flex flex-wrap items-stretch justify-center gap-4 md:gap-6">
          {CERTIFICATIONS.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp key={c.name} delay={0.06 * i}>
                <div
                  data-testid={`cert-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="group flex items-center gap-4 border border-ink/10 bg-paper px-6 py-5 grayscale hover:grayscale-0 transition-all duration-500 hover:border-leaf hover:shadow-2xl"
                >
                  <Icon size={30} className="text-leaf group-hover:text-leaf-bright transition-colors duration-500" />
                  <div>
                    <p className="font-display font-bold text-lg text-leaf tracking-tight leading-none">{c.name}</p>
                    <p className="mt-1 text-[11px] tracking-[0.15em] uppercase text-muted">{lang === "ta" ? TA.certSubs[i] : c.sub}</p>
                  </div>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
